import { Map } from "immutable";

import cache from "../../core/cache/actions";
import { Request, Response } from "../../core/comm";
import comm from "../../core/comm/actions";
import { applet as studentsApplet, urls as studentsUrls } from "../formando/common";

// /////////////////////////////////////////////////////////
//
// Urls
//
// /////////////////////////////////////////////////////////

const urls = {
  get: {
    parcels: "/v1/parcelas",
    students: "/v1/organizacoes/:org/formandos",
    formPayments: "/v1/formas_pagamento",
    leaveTypes: "/v1/tipos_multa_desistencia",
    formInfo: "/v1/organizacoes/:org/conclusao_info",
    typeCalc: "/v1/tipos_base_calculo_multa_desistencia",
    plans: "/v1/organizacoes/:org/planos_arrecadacao",
    // /////
    summaryPlans: "/v1/organizacoes/:org/planos_arrecadacao_resumidos",
    events: "v1/organizacoes/:org/eventos",
    contract: "/v1/organizacoes/:org/formandos/:student/contrato_resumo",
    contractBills: "/v1/organizacoes/:org/formandos/:student/contrato_parcelas",
    penalties: "v1/organizacoes/:org/contrato_multas_desistencia/:contract",
    contractDetail: "/v1/organizacoes/:org/formandos/:student/contrato_detalhes",
    payable: "/v1/organizacoes/:org/formas_pagamento/:formPayment/contas_credito",
    receiable: "/v1/organizacoes/:org/formas_pagamento/:formPayment/contas_debito",
    // eslint-disable-next-line max-len
    defaultPenalty: `/v1/organizacoes/:org/contrato_multas_desistencia/:contract/data/:baseDate`,

    contratos: "v1/formaturas/:org/formandos/:student/contratos",
  },
  post: {
    portions: "/v1/organizacoes/:org/parcelas_contrato",
    contract: "/v1/organizacoes/:org/formandos/:student/contratos",
    leave: "/v1/organizacoes/:org/formandos/:student/desistencia",
    indivualContract: "/v1/organizacoes/:org/formandos/:student/contratos/individual",
    previewContract: "/v1/organizacoes/:org/formandos/:student/contratos/pre_visualizacao/pdf",
  },
  put: {
    contract: "/v1/organizacoes/:org/formandos/:student/contratos/:contract",
  },
  combo: {
    accountsCredit: "/v1/organizacoes/:org/formas_pagamento/:paymentForm/contas_credito",
    accountsDebit: "/v1/organizacoes/:org/formas_pagamento/:paymentForm/contas_debito",
    accountPreviousCredit: "/v1/organizacoes/:org/contas_banc_credito_anterior",
    formPayment: "/v1/formas_pagamento",
    typesPenalty: "/v1/contrato_formando_tipos_multa",
    parcelsCombo: "/v1/formas_parcelamento",
  },
  download: {
    contract: "/v1/organizacoes/:org/formandos/:student/contratos/:contract/pdf",
  },
  pdf: {
    html:
      "v1/organizacoes/:org/formandos/:student/" +
      "contratos/pre_visualizacao/html?_broker=:broker&_token=:token" +
      "&codPlano=:plan&codParcelamento=:stallments" +
      "&dataPrimeiraParcela=:firstStallment",
    preview:
      "/v1/organizacoes/:org/formandos/:student/contratos/pre_visualizacao/" +
      "pdf?_broker=:broker&_token=:token&codPlano=:plan&" +
      "codParcelamento=:stallments&dataPrimeiraParcela=:firstStallment",
  },
};

// /////////////////////////////////////////////////////////
//
// Config
//
// /////////////////////////////////////////////////////////

const applet = "/formandos/contratos";
const views = {
  list: `${applet}/listar`,
  select: `${applet}/selecionar`,
  create: `/formaturas/:orgForm/formandos/:studentCode/contratos/cadastrar`,
  edit: `/formaturas/:orgForm/formandos/:studentCode/contratos/editar`,
  reactive: `/formaturas/:orgForm/formandos/:studentCode/contratos/reativar`,
  detail: `${applet}/detalhar`,
  leave: `${applet}/desistir/:formando`,
  signature: `${applet}/assinatura`,
  contratos: `/formaturas/:orgForm/formandos/:formando/contratos`,
};

function fetchSummaryContract(org, student) {
  return comm.get(
    Request({
      view: applet,
      url: urls.get.contract,
      urlParams: Map({ org, student }),
      onSuccess: Response({
        transform: (data) => data && data.first(Map()),
      }),
    }),
  );
}

function invalidateStudentsList() {
  return cache.invalidate(studentsApplet, studentsUrls.get.students);
}

export { urls, applet, views, fetchSummaryContract, invalidateStudentsList };
